<template>
  <client-email-events-modal
    :show="show"
    :edit-subject="subject"
    :client-name="fullName"
    :sent-date="date"
    :events="events"
    :loading="eventsLoading"
    @closed="onClosed"
  />
</template>
<script>
import { VALID_EVENTS } from '@/_store/events.module';
import ClientEmailEventsModal from './ClientEmailEventsModal';

const isDefined = (value) => value !== undefined && value !== null;

export default {
  name: 'ClientEmailEventsContainer',
  components: {
    ClientEmailEventsModal,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    customer: {
      type: Object,
      required: true,
      // eslint-disable-next-line camelcase
      validator: ({ first_name, last_name, email }) => isDefined(first_name) && isDefined(last_name)
          && isDefined(email),
    },
    subject: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: false,
    },
    outreachId: {
      type: Number,
      required: true,
      default: null,
    },
  },
  computed: {
    isAppointment() {
      return this.$route.name === 'AppointmentActivity';
    },
    isOutreach() {
      return ['admin.OutreachStats', 'OutreachStats'].includes(this.$route.name);
    },
    appointmentId() {
      return this.isAppointment ? this.$route.params.appointmentId : null;
    },
    events() {
      // eslint-disable-next-line no-undef
      return this.isAppointment
        ? this.$store.state.invitations.activityEvents
        : this.$store.state.events.filteredItems.filter((item) => VALID_EVENTS.includes(item.event.toLowerCase()));
    },
    eventsLoading() {
      console.log(this.outreachId);
      return this.isAppointment ? this.$store.state.invitations.isLoading
        : this.$store.state.events.filteredLoading;
    },
    fullName() {
      if (this.customer.display_name_array.length > 0) {
        return this.customer.display_name_array[0];
      } else {
        return 'Empty';
      }
    },
  },
  watch: {
    show(newval) {
      if (newval) {
        this.fetchEvents();
      }
    },
  },
  mounted() {
    this.fetchEvents();
  },
  methods: {
    fetchEvents() {
      if (this.isAppointment) {
        this.$store.dispatch('invitations/fetchActivityEvents', this.customer.invitationId);
      } else {
        this.$store.dispatch('events/fetchFiltered', {
          outreach: this.outreachId,
          customer_id: this.customer.pk,
        });
      }
    },
    onClosed() {
      this.$emit('closed');
      if (!this.isAppointment) this.$store.commit('events/resetFiltered');
    },
  },
};
</script>
<style lang="css"
  scoped>
</style>
